var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF6A34",
    d: "m22.65 21.178-6.957-6.957a7.96 7.96 0 0 0 1.664-4.896 7.99 7.99 0 0 0-2.355-5.681 7.98 7.98 0 0 0-5.681-2.355A7.99 7.99 0 0 0 3.64 3.644a7.97 7.97 0 0 0-2.355 5.68c0 2.146.839 4.166 2.355 5.682a7.97 7.97 0 0 0 5.68 2.354 7.97 7.97 0 0 0 4.895-1.66l6.956 6.953a.22.22 0 0 0 .31 0l1.168-1.165a.22.22 0 0 0 0-.31m-9.086-7.61a5.97 5.97 0 0 1-4.243 1.757 5.97 5.97 0 0 1-4.243-1.757 5.97 5.97 0 0 1-1.757-4.243c0-1.602.624-3.11 1.757-4.243a5.97 5.97 0 0 1 4.243-1.757c1.602 0 3.11.621 4.243 1.757a5.97 5.97 0 0 1 1.757 4.243c0 1.602-.624 3.11-1.757 4.243"
  })));
};
export default SvgSearch;